/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @module
 * @description
 * Entry point for all public APIs of the animation package.
 */
export {BrowserAnimationsModule,NoopAnimationsModule,ɵBrowserAnimationBuilder,ɵBrowserAnimationFactory,ɵAnimationRenderer,ɵAnimationRendererFactory} from './src/animations';



// WEBPACK FOOTER //
// ../../../../../packages/platform-browser/animations/public_api.ts